import react, { useEffect } from "react";
import cssClasses from "./ShowQrCode.module.css";
import defaultImage from "../../Assets/Images/Common/defaultEventImage.svg";
import mapImage from "../../Assets/Images/Common/map.svg";
export default function ShowQrCode() {
  const qrData = {
    eventImage: "",
    projectName: "Novaglobal",
    tokenDisplayNumber: "20220203-GT02-0001",
    eventName: "Sarita test",
    tokenTitle: "GT",
    eventDateTime: "Wed 1,Feb",
    projectLocation: "Pune",
    tokenIssued: "1-Feb-2023",
    tokenAmount: "₹3000",
  };

  return (
    <div style={{ position: "relative", width: "30%" }}>
      <div className={cssClasses.wrapperQr}>
        <div className={cssClasses.wrapperEventDetails}>
          <div>
            {qrData.eventImage === "" ? (
              <img
                className={cssClasses.eventImage}
                src={defaultImage}
                alt={"eventImage"}
              ></img>
            ) : (
              <img
                className={cssClasses.eventImage}
                src={defaultImage}
                alt={"eventImage"}
              ></img>
            )}
          </div>
          <div className={cssClasses.eventDetails}>
            <span className={cssClasses.projectName}>{qrData.projectName}</span>
            <span className={cssClasses.eventName}>{qrData.eventName}</span>
            <span className={cssClasses.eventDate}>{qrData.eventDateTime}</span>
            <span className={cssClasses.projectLocation}>
              {qrData.projectLocation}
              <a
                href="http://maps.google.com/?q=1200 Pennsylvania"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  style={{
                    width: "2rem",
                    height: "2rem",
                    objectFit: "contain",
                    marginLeft: "1rem",
                  }}
                  src={mapImage}
                  alt="map"
                ></img>
              </a>
            </span>
          </div>
        </div>
        <div className={cssClasses.borderBottom}>
          <div className={cssClasses.circleLeft}></div>
          <div className={cssClasses.circleRight}></div>
        </div>
        <div className={cssClasses.wrapperTokenDetails}>
          <div>
            <img
              className={cssClasses.eventImage}
              src={defaultImage}
              alt={"qrCode"}
            ></img>
          </div>
          <div className={cssClasses.tokenDetails}>
            <span className={cssClasses.tokenTitle}>{qrData.tokenTitle}</span>
            <span className={cssClasses.tokenNumber}>
              {qrData.tokenDisplayNumber}
            </span>
          </div>
        </div>
        <div className={cssClasses.borderBottom}>
          <div className={cssClasses.circle2Left}></div>
          <div className={cssClasses.circle2Right}></div>
        </div>
        <div className={cssClasses.tokenPaymentDetails}>
          <span className={cssClasses.tokenAmountTitle}>Token Amount</span>
          <span
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <span className={cssClasses.tokenAmount}>{qrData.tokenAmount}</span>
            <span className={cssClasses.tokenAmount}>{qrData.tokenIssued}</span>
          </span>
        </div>
      </div>
    </div>
  );
}
